import { Controller } from "@hotwired/stimulus"
import EmblaCarousel from "embla-carousel"

// Leichtgewichtiger Ersatz fuer den Swiper-basierten carousel_controller
// (Swiper-8-CDN-CSS vs Swiper-11-JS + .swiper-container/.swiper-Klassenmismatch
// liess overflow:hidden nicht greifen -> horizontaler Seiten-Overflow, der auf
// Mobile den "Jetzt bewerben"-Button aus dem Viewport schob). Embla clippt ueber
// .embla__viewport{overflow:hidden} rein per CSS, daher bleibt das Layout auch
// dann heil, wenn das JS gar nicht laedt.
export default class extends Controller {
  static targets = ["viewport"]
  static values = { options: Object }

  connect() {
    const node = this.hasViewportTarget ? this.viewportTarget : this.element
    this.embla = EmblaCarousel(node, {
      loop: false,
      align: "start",
      containScroll: "trimSnaps",
      ...this.optionsValue
    })
  }

  disconnect() {
    if (this.embla) {
      this.embla.destroy()
      this.embla = undefined
    }
  }

  scrollPrev() {
    if (this.embla) this.embla.scrollPrev()
  }

  scrollNext() {
    if (this.embla) this.embla.scrollNext()
  }
}
